{
    "RangeCombo_Search_Placeholder": "Procurar...",
    "NAME": "RangeComboLanguage",
    "Validation_Generic_Error_Message": "Há um ou mais erros detetados de momento.",
    "Validation_Generic_Error_Max_Entries": "Atingiu\/ultrapassou o número máximo de entradas.",
    "RangeCombo_Search_More_Options_Message": "Procure mais opções"
}